// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-container {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.notifications-column {
  display: flex;
  flex-direction: column;
}

body .form-group label.notifications-column {
  font-weight: 400;
}

.notifications-disabled {
  opacity: 0.4;
  pointer-events: none;
}

.notifications-section {
  border-top: 1px solid rgba(0, 0, 0, 0.1019607843);
  padding-top: 25px;
  margin-top: 15px;
}

.notifications-content {
  padding: 30px 24px 30px 24px;
  gap: 24px;
  background: #fefefe;
  border: 1px solid #e8ecef;
  border-radius: 12px;
}

.notifications-content h4 {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.notifications-content .form-group {
  margin-bottom: 0px;
}

.notifications-content .form-group label {
  color: #141718;
}

.notifications-input-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 14px 16px;
  gap: 12px;
  background: #f3f5f7;
  border-radius: 12px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Notifications/notifications.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,iDAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,4BAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AACF","sourcesContent":[".notifications-container {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n}\n\n.notifications-column {\n  display: flex;\n  flex-direction: column;\n}\n\nbody .form-group label.notifications-column {\n  font-weight: 400;\n}\n\n.notifications-disabled {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.notifications-section {\n  border-top: 1px solid #0000001a;\n  padding-top: 25px;\n  margin-top: 15px;\n}\n\n.notifications-content {\n  padding: 30px 24px 30px 24px;\n  gap: 24px;\n  background: #fefefe;\n  border: 1px solid #e8ecef;\n  border-radius: 12px;\n}\n\n.notifications-content h4 {\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.notifications-content .form-group {\n  margin-bottom: 0px;\n}\n\n.notifications-content .form-group label {\n  color: #141718;\n}\n\n.notifications-input-option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 14px 16px;\n  gap: 12px;\n  background: #f3f5f7;\n  border-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
